module.exports = __webpack_public_path__ + "static/media/productCategory-02.ed136ebb.png";